/**
 *  EDAP events
 */

const actionlocation = 'trending-module';

export const TRENDING_DESTINATION_LINK_CLICK = ({ lbsUuid }) => ({
  name: 'destination.link.click',
  data: {
    actionlocation,
    eventlbsuuid: lbsUuid
  }
});

export const TRENDING_CLICK_PREV = {
  name: 'nav.previous.click',
  data: {
    actionlocation
  }
};

export const TRENDING_CLICK_NEXT = {
  name: 'nav.next.click',
  data: {
    actionlocation
  }
};

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};

export const DATEPICKER_EXPOSURE_EVENT = ({ variant }) => ({
  name: 'test.exposure',
  data: {
    testname: 'HA_HP_NewCarouselDatePicker_',
    variant
  }
});

export const ADDITIONAL_INFO_EXPOSURE_EVENT = ({ variant }) => ({
  name: 'test.exposure',
  data: {
    testname: 'ptaHpAditionalInfoTrendingDestinations',
    variant: `${variant}`
  }
});

export const TITLES_EXPOSURE_EVENT = ({ variant }) => ({
  name: 'test.exposure',
  data: {
    testname: 'hp5022',
    variant: `${variant}`
  }
});



// WEBPACK FOOTER //
// ./src/universal/components/Trending/events.js